/**
 * Brew's legal pages on docs.brew.new: the footer links them, and the
 * enterprise page lists them for procurement reviews.
 */
export const LEGAL_LINKS: ReadonlyArray<{ label: string; href: string }> = [
  {
    label: 'Privacy',
    href: 'https://docs.brew.new/legal/privacy-policy',
  },
  {
    label: 'Terms',
    href: 'https://docs.brew.new/legal/terms-of-service',
  },
  {
    label: 'Acceptable use',
    href: 'https://docs.brew.new/legal/acceptable-use-policy',
  },
  {
    label: 'DPA',
    href: 'https://docs.brew.new/legal/data-protection-addendum',
  },
  {
    label: 'GDPR',
    href: 'https://docs.brew.new/legal/gdpr-and-your-data',
  },
  {
    label: 'Subprocessors',
    href: 'https://docs.brew.new/legal/subprocessors',
  },
]
